module.exports = __webpack_public_path__ + "static/image2-273d10389849a8e5e47ef0a44282c2a0.jpg";